import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseManagementService } from '@edtech-ui/core/services/course-management/course-management.service';

@Component({
	selector: 'app-course-creation-outcome',
	standalone: true,
	imports: [ReactiveFormsModule, MatIconModule],
	templateUrl: './course-creation-outcome.component.html',
	styleUrl: './course-creation-outcome.component.scss'
})
export class CourseCreationOutcomeComponent {

	createCourseForm!: FormGroup;
	classroomId: any;

	constructor(
		private router: Router,
		private courseService: CourseManagementService,
		private route: ActivatedRoute
	) {
		const payload = this.courseService.getPayload();
		this.createCourseForm = new FormGroup({
			course_outcomes: new FormControl(payload.course_outcomes?.join('\n') || '', [Validators.required])
		});
		this.createCourseForm.valueChanges.subscribe(val => {
			const outcomesArray = val.course_outcomes
				.split('\n')
				.map((outcome: string) => outcome.trim())
				.filter((outcome: string) => outcome.length > 0);

			this.courseService.updatePayload({ course_outcomes: outcomesArray });
		});
	}

	ngOnInit(): void {
		this.route.parent?.paramMap.subscribe(params => {
			this.classroomId = params.get('classroomId') ?? '';
		});
	}
	goToPrePage() {
    this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation', 'add-units']);
	}

	goToNextPage() {
		if (this.createCourseForm.invalid) return;
		this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation','add-resources']);
	}
}
